import React from 'react';
import { cn } from '../../utils/cn';

interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'destructive';
  children: React.ReactNode;
}

interface AlertDescriptionProps extends React.HTMLAttributes<HTMLParagraphElement> {
  children: React.ReactNode;
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(
  ({ className, variant = 'default', children, ...props }, ref) => {
    const variants = {
      default: 'border-gray-200 dark:border-gray-700 bg-white/60 dark:bg-gray-800/60 backdrop-blur-md text-gray-900 dark:text-gray-100',
      destructive: 'border-danger-200 bg-danger-50 text-danger-900',
    };

    return (
      <div
        ref={ref}
        role='alert'
        className={cn('relative w-full rounded-lg border p-4', variants[variant], className)}
        {...props}
      >
        {children}
      </div>
    );
  },
);
Alert.displayName = 'Alert';

const AlertDescription = React.forwardRef<HTMLParagraphElement, AlertDescriptionProps>(
  ({ className, children, ...props }, ref) => (
    <div ref={ref} className={cn('text-sm [&_p]:leading-relaxed', className)} {...props}>
      {children}
    </div>
  ),
);
AlertDescription.displayName = 'AlertDescription';

export { Alert, AlertDescription };
